import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { baseItems, baseUrl, premiumItems, premiumUrl } from '../data/offer';
type CheckLineProps = {
  children: React.ReactNode;
  premium?: boolean;
};
function CheckLine({
  children,
  premium = false
}: CheckLineProps) {
  return <li className="flex items-start gap-3 text-sm leading-snug text-muted" data-id="element-210" data-mp="1j9qoae3mxmfl">
      <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${premium ? 'text-aqua' : 'text-teal'}`} data-id="element-211" data-mp="1nbbuxhpkt4hc" />
      {children}
    </li>;
}
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-white py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-212" data-mp="1x8zs0eanmo2o">
      <div className="mx-auto max-w-5xl px-4" data-id="element-213" data-mp="228cqjwaw1jl3">
        <div className="text-center" data-id="element-214" data-mp="227b4yxw8xep4">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-215" data-mp="2up6oft9qc1n">Acceso inmediato</p>
          <h2 id="pricing-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-216" data-mp="7tih1zd9dmxl">Elegí tu Megapack</h2>
          <p className="mt-3 text-muted" data-id="element-217" data-mp="1mgy5d0qmzkr3">Dos opciones · Mismo acceso inmediato</p>
        </div>

        <div className="mt-12 grid items-stretch gap-7 lg:grid-cols-2" data-id="element-218" data-mp="1hpoi26sk8tid">
          <article className="flex flex-col rounded-3xl border border-line bg-mist p-6 text-ink shadow-card sm:p-8" data-id="element-219" data-mp="1cqv4ked9x2i7">
            <p className="text-xs font-extrabold uppercase tracking-[.15em] text-muted" data-id="element-220" data-mp="17sadp5jwvv6f">Opción 1</p>
            <h3 className="mt-3 text-2xl font-bold" data-id="element-221" data-mp="25g2ba0mvsyej">Megapack Instrumentación Quirúrgica Listo™</h3>
            <p className="mt-2 font-bold text-teal" data-id="element-222" data-mp="20fxvydxpm9pw">6 tomos + 4 bonos</p>
            <div className="mt-7" data-id="element-223" data-mp="20emnw1x8efsz">
              <span className="text-sm text-muted line-through" data-id="element-224" data-mp="1vgl7jor6wul7">$72.000 ARS</span>
              <p className="mt-1 font-display text-5xl font-extrabold text-petrol" data-id="element-225" data-mp="1rg198huvrkxh">
                $19.990 <small className="font-sans text-base" data-id="element-226" data-mp="k1xxz8ifcu5a">ARS</small>
              </p>
            </div>
            <ul className="mt-7 flex-1 space-y-3" data-id="element-227" data-mp="g0ui4m0dmy42">
              {baseItems.map(item => <CheckLine key={item} data-id="element-228" data-mp="hhrs2va92tm3">{item}</CheckLine>)}
            </ul>
            <Button href={baseUrl} target="_blank" rel="noopener noreferrer" variant="petrol" arrow className="mt-8 w-full" data-id="element-229" data-mp="hfx9voqd5flp">
              QUIERO MI MEGAPACK AHORA
            </Button>
          </article>

          <article className="relative flex flex-col rounded-3xl border-2 border-aqua bg-mist p-6 text-ink shadow-lift sm:p-8" data-id="element-230" data-mp="cioo7e60atfp">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-aqua px-4 py-2 text-xs font-extrabold text-petrolDark shadow-lg" data-id="element-231" data-mp="3uwecqbxzajqn">
              <StarIcon className="mr-1 inline h-3.5 w-3.5 fill-current" data-id="element-232" data-mp="3kyi69xfzkcyv" />
              MÁS ELEGIDO
            </span>
            <p className="mt-3 text-xs font-extrabold uppercase tracking-[.15em] text-muted" data-id="element-233" data-mp="3px1t002elssa">Opción 2</p>
            <h3 className="mt-3 text-2xl font-bold" data-id="element-234" data-mp="3bxjxl1ulrh9y">Megapack + Upsell Premium</h3>
            <p className="mt-2 font-bold text-teal" data-id="element-235" data-mp="3fz5h361n6tt4">6 tomos + 4 bonos + 2 módulos avanzados</p>
            <div className="mt-7" data-id="element-236" data-mp="2xatmj8r2uab6">
              <span className="text-sm text-muted line-through" data-id="element-237" data-mp="2xc4or44vja06">$110.000 ARS</span>
              <p className="mt-1 font-display text-5xl font-extrabold text-petrol" data-id="element-238" data-mp="2scs3uoxkcd08">
                $27.990 <small className="font-sans text-base" data-id="element-239" data-mp="36cb0olkxc1x8">ARS</small>
              </p>
            </div>
            <ul className="mt-7 flex-1 space-y-3" data-id="element-240" data-mp="31c6srjy30fim">
              <CheckLine premium data-id="element-241" data-mp="31bdlmhv7nnzy">
                <b className="text-ink" data-id="element-242" data-mp="3g9phwneo8uql">Todo el Megapack base, más:</b>
              </CheckLine>
              {premiumItems.map(item => <CheckLine key={item} premium data-id="element-243" data-mp="3ba33ian3x8g7">
                  <b className="font-semibold text-teal" data-id="element-244" data-mp="3p29gxoyvl1by">{item}</b>
                </CheckLine>)}
            </ul>
            <Button href={premiumUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full" data-id="element-245" data-mp="3l0fjrqnw2fgj">
              QUIERO EL MEGAPACK + UPSELL PREMIUM
            </Button>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-246" data-mp="3u1m5qf9b4ih6">
              Podés pagar con tarjeta de crédito o débito, transferencia bancaria o Mercado Pago en pesos argentinos.
            </p>
          </article>
        </div>
      </div>
    </section>;
}